import { render, staticRenderFns } from "./supplier-activity-form.vue?vue&type=template&id=19b9b4a6"
import script from "./supplier-activity-form.vue?vue&type=script&lang=js"
export * from "./supplier-activity-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports